import List from "./pages/List";
import Wizard from "./pages/Wizard";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["COMPANY_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["COMPANY_MODULE"],
  },
];

export default routes;
